import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingDairyManureStorage, getFootprintingDairyManureStorageAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_DAIRY_MANURE_STORAGE } from "consts";

export const useGetFootprintingDairyManureStorage = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_DAIRY_MANURE_STORAGE, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingDairyManureStorageAdmin(primaryDataId ?? "") : getFootprintingDairyManureStorage(primaryDataId ?? "")),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
